import Component from '../abstracts/Component';

export default class ListingHeadComponent extends Component {

  get SELECTORS() {
    return {
      listingHead: '[data-listing-head]',
      fixedEl: '[data-listing-head-fixed]',
      header: '[data-js-component="HeaderComponent"]',
      resultsCount: '[data-results-count]'
    };
  }

  get CSS_CLASSNAMES() {
    return {
      menuOpen: 'menu-open',
      fixed: '--fixed'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.height = this.$component.getBoundingClientRect().height;
    this.header = document.querySelector(this.SELECTORS.header);
    this.listingHead = this.$component;
    this.fixedEl = this.$component.querySelector(this.SELECTORS.fixedEl);
    this.resultsCount = this.$component.querySelector(this.SELECTORS.resultsCount);
  }

  onMenuEventsActive() {
    this.$on(this.$customEvents.MENU_EVENTS.active, () => {
      this.$component.classList.add(this.CSS_CLASSNAMES.menuOpen);
    });
  }

  onMenuEventsInactive() {
    this.$on(this.$customEvents.MENU_EVENTS.inactive, () => {
      this.$component.classList.remove(this.CSS_CLASSNAMES.menuOpen);
    });
  }

  onFiltersEventsUpdated() {
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      let newCount = payload.response.querySelector(this.SELECTORS.resultsCount).innerHTML;
      if (this.resultsCount != null) {
        this.resultsCount.innerHTML = newCount;
      }
    });
  }

  onWindowScroll() {
    if (this.$component.getBoundingClientRect().top < this.header.offsetHeight) {
      const headerHeight = this.header.getBoundingClientRect().height - 1;
      this.fixedEl.classList.add(this.CSS_CLASSNAMES.fixed);
      this.fixedEl.style.top = `${headerHeight}px`;
    } else {
      this.fixedEl.classList.remove(this.CSS_CLASSNAMES.fixed);
      this.fixedEl.style.top = `0`;
    }
  }

  render() {
    super.render();
    this.bindEvents();

    // this is needed to obtain right dimensions
    if (this.listingHead.offsetWidth >= 1600) {
      this.listingHead.style.padding = 0;
    }
  }

  bindEvents() {
    this.onMenuEventsActive();
    this.onMenuEventsInactive();
    this.onFiltersEventsUpdated();

    document.addEventListener('scroll', () => this.onWindowScroll());
    document.addEventListener('resize', () => this.onWindowScroll());
  }
}
